import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    fixturesPage: null,
    fixtures: null,
    standings: null
  },
  getters: {
    FIXTURES_PAGE: state => state.fixturesPage,
    FIXTURES: state => state.fixtures,
    STANDINGS: state => state.standings
  },
  mutations: {
    SET_FIXTURES_PAGE: (state, payload) => {
      state.fixturesPage = payload
    },
    SET_FIXTURES: (state, payload) => {
      state.fixtures = payload
    },
    SET_STANDINGS: (state, payload) => {
      state.standings = payload
    }
  },
  actions: {
    FETCH_FIXTURES_PAGE: async (context, payload) => {
      try {
        const response = await Axios.get(
          `/football/fixtures/page?timezone=${payload.timezone}`
        )
        context.commit('SET_FIXTURES_PAGE', response.data)
      } catch (error) {
        context.commit('SET_FIXTURES_PAGE', error.response.data)
      }
    },
    FETCH_FIXTURES: async (context, payload) => {
      try {
        const response = await Axios.get(`/football/fixtures/${payload}`)
        context.commit('SET_FIXTURES', response.data)
      } catch (error) {
        context.commit('SET_FIXTURES', error.response.data)
      }
    },
    FETCH_STANDINGS: async context => {
      try {
        const response = await Axios.get(`/football/standings`)
        context.commit('SET_STANDINGS', response.data)
      } catch (error) {
        context.commit('SET_STANDINGS', error.response.data)
      }
    }
  }
}
